module.exports = __webpack_public_path__ + "static/media/image_circle_post.81aa83d4.png";